import axios from 'axios'
import { BUSCAR_CONFIGURACAO_EXCESSO_BAGAGEM } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarConfiguracaoExcessoBagagem(empresaId) {
  const url = `${URL}/empresas/${empresaId}/configuracao-excesso-bagagem`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_CONFIGURACAO_EXCESSO_BAGAGEM,
      payload: response
    })
  );
}
